import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';
import { FillableIcon } from '../IconTypes';

const IconReport: FC<FillableIcon> = ({ className, color, filled = false }: FillableIcon) => {
  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {filled ? (
        <>
          <mask id="path-1-inside-1_3339_172" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 1H20L28 9V31H4V1ZM19 3V10H26L19 3ZM11 20H9V26H11V20ZM13 17H15V26H13V17ZM19 19H17V26H19V19ZM21 14H23V26H21V14Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 1H20L28 9V31H4V1ZM19 3V10H26L19 3ZM11 20H9V26H11V20ZM13 17H15V26H13V17ZM19 19H17V26H19V19ZM21 14H23V26H21V14Z"
            fill={fillColor}
          />
          <path
            d="M20 1L21.4142 -0.414211L20.8285 -1H20V1ZM4 1V-1H2V1H4ZM28 9H30V8.17158L29.4142 7.58579L28 9ZM28 31V33H30V31H28ZM4 31H2V33H4V31ZM19 10H17V12H19V10ZM19 3L20.4142 1.58579L17 -1.82843V3H19ZM26 10V12H30.8284L27.4142 8.58579L26 10ZM9 20V18H7V20H9ZM11 20H13V18H11V20ZM9 26H7V28H9V26ZM11 26V28H13V26H11ZM15 17H17V15H15V17ZM13 17V15H11V17H13ZM15 26V28H17V26H15ZM13 26H11V28H13V26ZM17 19V17H15V19H17ZM19 19H21V17H19V19ZM17 26H15V28H17V26ZM19 26V28H21V26H19ZM23 14H25V12H23V14ZM21 14V12H19V14H21ZM23 26V28H25V26H23ZM21 26H19V28H21V26ZM20 -1H4V3H20V-1ZM29.4142 7.58579L21.4142 -0.414211L18.5858 2.41421L26.5858 10.4142L29.4142 7.58579ZM30 31V9H26V31H30ZM4 33H28V29H4V33ZM2 1V31H6V1H2ZM21 10V3H17V10H21ZM26 8H19V12H26V8ZM17.5858 4.41421L24.5858 11.4142L27.4142 8.58579L20.4142 1.58579L17.5858 4.41421ZM9 22H11V18H9V22ZM11 26V20H7V26H11ZM11 24H9V28H11V24ZM9 20V26H13V20H9ZM15 15H13V19H15V15ZM17 26V17H13V26H17ZM13 28H15V24H13V28ZM11 17V26H15V17H11ZM17 21H19V17H17V21ZM19 26V19H15V26H19ZM19 24H17V28H19V24ZM17 19V26H21V19H17ZM23 12H21V16H23V12ZM25 26V14H21V26H25ZM21 28H23V24H21V28ZM19 14V26H23V14H19Z"
            fill={fillColor}
            mask="url(#path-1-inside-1_3339_172)"
          />
        </>
      ) : (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 3H6V29H26V11H18V3ZM25.1716 9L20 3.8284V9H25.1716ZM4 1H20L28 9V31H4V1ZM9 20H11V26H9V20ZM15 17H13V26H15V17ZM19 19V26H17V19H19ZM23 14H21V26H23V14Z"
          fill={fillColor}
        />
      )}
    </svg>
  );
};

export default IconReport;
